import { useState } from "react";
import { ContainerFirmaOrden } from "./localStyle";
import FirmaDocumento from "global/component/Genericos/FirmaDocumento/FirmaDocumento";

const FirmaOrden = ({ finalizarProceso,idTurno }) => {
  const [firma, setFirma] = useState("");

  const handleClick = () => {
    const dto = {
      binario: firma,
      idRemoto: idTurno,
      tag: "png",
      autocheck: true,
    }
    finalizarProceso(dto, "firmaOrden");
  };
  const onChange = (firma) => {
    setFirma(firma);
  };

  return (
    <ContainerFirmaOrden>
      <span>Firma de la orden</span>
      <span>
        Ahora ingrese su firma con el dedo en el rectangulo de abajo y luego
        toque firmar.
      </span>

      <FirmaDocumento onClick={handleClick} onChange={onChange} />
    </ContainerFirmaOrden>
  );
};

export default FirmaOrden;
